/*
Copyright MITSUBISHI Elec.
*/

//---------------------------------------
//リクエスト/レスポンスパラメータ定数定義。
//---------------------------------------

/**
 * レスポンスパラメータ定数定義クラス
 * 
 * @module -
 * @class ResponseParamConstants
 */

/** レスポンス定義 [汎用]: ステータス */
ResponseParamConstants.KEY_RESPONSE_STATUS = "status";
/** レスポンス定義 [汎用]: サブステータス */
ResponseParamConstants.KEY_RESPONSE_SUB_STATUS = "subStatus";
/** レスポンス定義 [汎用]: メッセージ */
ResponseParamConstants.KEY_RESPONSE_MSG = "msg";
/** レスポンス定義 [汎用]: エンティティID
 * @property KEY_RESPONSE_ENTITY_ID エンティティID
 */
ResponseParamConstants.KEY_RESPONSE_ENTITY_ID = "entityId";
/** レスポンス定義 [汎用]: ファイル名/ダウンロード用 */
ResponseParamConstants.KEY_RESPONSE_FILENAME = "fileName";

/**
 * レスポンスパラメータ定数定義クラス
 * @class RequestParamConstants
 */
function ResponseParamConstants() {
}

/** リクエスト定義 [汎用]: 強制フラグ */
RequestParamConstants.KEY_FORCE_FLAG = "forceFlag";
/** リクエスト定義 [汎用]: 処理モード */
RequestParamConstants.KEY_OPERATION_MODE = "operationMode";
/** リクエスト定義 [汎用]: ファイル名 */
RequestParamConstants.KEY_FILENAME = "fileName";
/** リクエスト定義 [汎用]: 画面ID */
RequestParamConstants.KEY_SCREEN_ID = "screenId";

/** リクエスト定義 [汎用]: ダッシュボード業務ID */
RequestParamConstants.KEY_DASHBOARD_BIZ_ID = "dashboardBizId";
/** リクエスト定義 [汎用]: ダッシュボードアプリID */
RequestParamConstants.KEY_DASHBOARD_APP_ID = "dashboardAppId";

/**
 * リクエストパラメータ定数定義クラス
 * @class RequestParamConstants
 */
function RequestParamConstants() {
}

/*
Copyright MITSUBISHI Elec.
*/
